import React, { useState, useEffect } from "react";
import EditOrAddEmployeeSalary from "../EditOrAddEmployeeSalary/EditOrAddEmployeeSalary";
import { useGetEmployeeSalaryData } from "../../../queries/employeeQueries";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";
import moment from "moment";
const SalaryDetailsInfo = ({ employee }) => {
  const user = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(user, userRoles.HR);
  const isAdmin = userRoleAuth(user, userRoles.TENANTADMIN);
  const isHrOrAdminRole = isAdmin || isHr;
  const [isModalOpen, setIsModalOpen] = useState(false);
 
  const { data, isLoading, refetch } = useGetEmployeeSalaryData({
    employee_id: employee?.employee_id,
  });

  const salaryData = data?.data?.[0] ?? null;


  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);;
  };

  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">Salary</p>
        </div>
        <div>
          {isHrOrAdminRole && (
            <img
              src="/images/editicon.svg"
              alt="Edit"
              className="cursor-pointer"
              onClick={handleOpenModal}
            />
          )}
        </div>
      </div>
      {isLoading ? (
        <p>Loading salary details...</p>
      ) : (
        <div className="flex justify-between employee-info-card">
          <table className="border-0">
            <tbody>
              <tr>
                <td className="title">Annual CTC</td>
                <td className="data">Rs {salaryData?.ctc || "N/A"}</td>
                <td className="title">Effective Date</td>
                <td className="data">
                  {salaryData?.effective_date
                    ? moment(salaryData?.effective_date).format("DD MMMM YYYY")
                    : "N/A"}
                </td>
              </tr>
              <tr>
                <td className="title">Last Revision </td>
                <td className="data">
                  {salaryData?.created_date
                    ? moment(salaryData?.created_date).format("DD MMMM YYYY")
                    : "N/A"}
                </td>

                <td className="title">Last Payout Month </td>
                {/* <td className="data">N/A</td> {Will be updated after we integrate with payslip} */}
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {isModalOpen && (
        <EditOrAddEmployeeSalary
          openModal={isModalOpen}
          onCloseModal={handleCloseModal}
          employee={employee}
          salaryData={salaryData}
        />
      )}
    </div>
  );
};

export default SalaryDetailsInfo;
